module.exports = __webpack_public_path__ + "static/media/Cho Chang 2.8a517bb7.jpg";